// This file can be deleted once everything is migrated.
// Currently duplicate file present under mortgage-calculator/shared/breakdown-details
// Dependencies

import React from 'react';

import classnames from 'classnames';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import { get, isFunction, map, reduce } from 'lodash';
import PropTypes from 'prop-types';

import { Num } from '@nerdwallet/nw-client-lib';

// Components
import { applyMacros } from '@nerdwallet/react-config-builder';

// Local Components
import ConfigBuilderWrapper from '../../config-builder-wrapper/config-builder-wrapper';
import SimpleLineChart from '../../simple-bar-chart/simple-bar-chart';

// CSS
require('./breakdown-details.less');

function getFirstKeyValue(data, itemConfig) {
  // TODO - we should remove this hard wiring.
  const firstKeyConfig = itemConfig.value.keys[0];
  return firstKeyConfig.key
    ? get(data, firstKeyConfig.key)
    : firstKeyConfig.getValue(data);
}

const BreakdownDetails = (props) => {
  const { data, config, className, onChange } = props;

  const max = reduce(
    config,
    (currMax, itemConfig) =>
      Math.max(currMax, getFirstKeyValue(data, itemConfig)),
    0
  );

  const configBuilderProps = {
    data,
    onChange,
  };

  return (
    <div className={classnames('breakdown-details', className)}>
      {map(config, (itemConfig, i) => {
        const resolvedConfig = applyMacros(itemConfig.value, data);
        let value = Num.value(
          resolvedConfig.value || getFirstKeyValue(data, itemConfig)
        );
        const delta = Num.value(resolvedConfig.delta);
        const deltaLabel = (delta > 0 ? '+' : '') + resolvedConfig.deltaLabel;

        // If delta is negative, we need to add it to the value as it will be 'taken' from the value
        if (delta < 0) {
          value -= delta;
        }

        if (
          isFunction(itemConfig.isVisible) &&
          itemConfig.isVisible(data) === false
        ) {
          return undefined;
        }

        const lineChartProps = {
          max,
          value,
          delta,
          label: delta ? deltaLabel : '',
        };

        return (
          <div
            key={`breakdown-details-title-${i}`}
            className={classnames(
              'breakdown-details-row',
              'nw-inline-input',
              itemConfig.className
            )}
          >
            <div className="breakdown-details-row-name">
              <ConfigBuilderWrapper
                {...configBuilderProps}
                viewConfig={itemConfig.title}
              />
            </div>
            <div className="breakdown-details-row-value">
              <ConfigBuilderWrapper
                {...configBuilderProps}
                viewConfig={itemConfig.value}
              />
            </div>
            <div className="breakdown-details-row-chart">
              <SimpleLineChart {...lineChartProps} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

BreakdownDetails.displayName = 'BreakdownDetails';

BreakdownDetails.propTypes = {
  data: PropTypes.object.isRequired,
  config: PropTypes.array.isRequired,
  className: PropTypes.string,
  onChange: PropTypes.func,
};

BreakdownDetails.defaultProps = {
  className: null,
  onChange: () => {},
};

export default BreakdownDetails;
